import videoFile from '../Assets/video/1000060398.mp4';

function Loader() {

    const loaderStyle = {
        position: 'fixed',
        top: 0,
        left: 0,
        background: 'rgb(255, 255, 255)',
        height: '100%',
        width: '100%',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        zIndex: 9999,
    };

    const contentWrapperStyle = {
        display: 'flex',
        flexDirection: 'column', // Stack items vertically
        alignItems: 'center',     // Center horizontally
    };

    const loaderVideoStyle = {
        maxWidth: '250px',
        maxHeight: '250px',
        backgroundColor: 'transparent',
        mixBlendMode: 'multiply',
    };

    const textStyle = {
        marginTop: '10px',
        fontSize: '18px',
        color: '#333',
        fontWeight: 'bold',
        textAlign: 'center',
    };

    return (
        <div style={loaderStyle}>
            <div style={contentWrapperStyle}>
                <video 
                    autoPlay 
                    muted 
                    loop 
                    style={loaderVideoStyle}
                >
                    <source 
                        src={videoFile} 
                        type="video/mp4" 
                        onError={(e) => console.error('Video error:', e)}
                    />
                    Your browser does not support the video tag.
                </video>
                <div style={textStyle}>
                    Downloading... This may take about 3-7 minutes. Please wait.
                </div>
            </div>
        </div>
    );
}

export default Loader;